export default "__VITE_ASSET__pe7UnJeO__"